import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from "../shared/user.service";
import { User } from "../shared/user";
import { AngularFireAuth } from "angularfire2/auth";
import { ObjectObservable } from "../../shared/base/object-observable";
import { NavService } from "../../core/nav.service";

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html'
})
export class UserDetailComponent implements OnInit, OnDestroy {
  userObservable: ObjectObservable<User>;

  constructor(
    private nav: NavService,
    private userService: UserService,
    private afAuth: AngularFireAuth) { }

  ngOnInit() {
    this.initNav();
    this.afAuth.authState.subscribe(auth => {
      if(auth) {
         this.userObservable = this.userService.readChild(auth.uid);
         this.nav.userObservable = this.userObservable;
      }
    });
  }

  private initNav(): void {
    this.nav.title = '프로필';
    this.nav.userDetail = true;
    this.nav.actions = null;
  }

  ngOnDestroy() {
    this.nav.userDetail = false;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/user-detail/user-detail.component.ts